module.exports = __webpack_public_path__ + "media/app/assets/races/void_elf_female-86d362a49f75c90c0bfc90bc25f8fe13.png";